import { Screen } from '@rahtab/stack-navigator';
import { TextInput, Card, getSpacing, Picker, TextAreaInput, Button } from '@rahtab/ui';
import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { useSendMessage } from './useSendMessage';

const mainProblem = [
  {
    label: 'مشکلات سخت افزاری: مربوط به دستگاه پوز',
    value: 'hardware',
  },
  {
    label: 'مشکلات نرم‌افزاری: مربوط به سامانه رهتاب',
    value: 'software',
  },
  {
    label: 'مشکلات شهروندان: مربوط به ثبت‌نام و یا خرید',
    value: 'people',
  },
];
const subProblem: any = {
  hardware: [
    {
      label: 'دستگاه پیغام «کالایی یافت نشد» می‌دهد.',
      value: 'not_found',
    },
    {
      label: 'دستگاه پیغام «خطا در شبکه» می‌دهد.',
      value: 'network_problem',
    },
    {
      label: 'دستگاه برای مدتی طولانی پیغام «لطفا صبر کنید» می‌دهد.',
      value: 'infinite_waiting',
    },
    {
      label: 'دستگاه کاغذ دارد ولی رسید چاپ نمی‌کند.',
      value: 'no_reciet',
    },
    {
      label: 'دستگاه پیغام «سهمیه تمام شده است» می‌دهد. ',
      value: 'out_of_share',
    },
    {
      label: 'دستگاه پیغام «موجودی کالا کافی نیست» می‌دهد.',
      value: 'not_enough',
    },
  ],
  software: [
    {
      label: 'بار دریافت شده را نمیتوان اعلام وصول کرد.',
      value: 'unable_to_submit_load',
    },
    {
      label: 'بار دریافتی وصول شده است ولی نمی توان آن را عرضه نمود.',
      value: 'submitted_not_able_present',
    },
    {
      label: 'بار عرضه شده نمایش داده نمی‌شود و یا مشکل دارد.',
      value: 'load_not_shown',
    },
    {
      label: 'بار عرضه شده را نمی‌توان غیر فعال نمود.',
      value: 'loads_dont_get_inactive',
    },
  ],
  people: [
    {
      label: 'شهروند پیامک ثبت نام ارسال کرده است ولی جواب نیامده است.',
      value: 'no_message_recieved',
    },
    {
      label: 'دستگاه پیغام «سهمیه تمام شده است» می‌دهد، در صورتی که شهروند ادعا کند سهمیه نگرفته است.',
      value: 'out_of_share_customer_says_no',
    },
  ],
};
const NewMessage = () => {
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [titleLabel, setTitleLabel] = useState('');
  const [subtitleLabel, setSubtitleLabel] = useState('');
  const [text, setText] = useState('');
  const [sendButton, setSendButton] = useState(true);
  const { loading, sendMessage } = useSendMessage();

  return (
    <Screen
      transparentLoading={loading}
      title="ارسال پیام جدید"
      renderMain={() => {
        return (
          <Card style={styles.card}>
            <Picker
              onSelectValue={setTitle}
              onSelectLabel={setTitleLabel}
              selectedValue={title}
              placeholder="عنوان پیام خود را انتخاب نمایید.">
              {mainProblem.map((item, index) => {
                return <Picker.Item label={item.label} value={item.value} key={`problem-${index}`} />;
              })}
            </Picker>
            {!!title && (
              <Picker
                onSelectValue={setSubtitle}
                onSelectLabel={(label) => {
                  setSubtitleLabel(label);
                  setSendButton(false);
                }}
                selectedValue={subtitle}
                placeholder="نوع مشکل خود راانتخاب نمایید.">
                {subProblem[title].map((item: any, index: number) => {
                  return <Picker.Item label={item.label} value={item.value} key={`subProblem-${index}`} />;
                })}
              </Picker>
            )}
            <TextAreaInput
              label="متن پیام"
              value={text}
              onChangeText={setText}
              placeholder="متن پیام خود را وارد نمایید."
            />
            <Button
              color="secondary"
              disabled={sendButton}
              text="ارسال پیام به پشتیبانی"
              onPress={() => sendMessage({ title: titleLabel, text: `${subtitleLabel} ${text}` })}
            />
          </Card>
        );
      }}
    />
  );
};
export default NewMessage;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(),
    padding: getSpacing(),
  },
});
